import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CHECKBOX_TRADE_DISCOUNT } from '../../../../cartAndOrders/constant'
import {
  selectCheckDisCountAndVoucher,
  selectDiscountOrder,
  selectVoucher,
} from '../../../../cartAndOrders/store/slice'
import useGetVAT from '../../../../common/category/useVAT'
import useViewport from '../../../../common/hooks/useViewport'
import { Element } from '../../../../common/html/element'
import { ScrollComponent } from '../../../../common/scrollComponent'
import classes from '../../../index.module.scss'
import {
  selectBuyPackage,
  selectUniquePackageTypes,
  setListPackage,
} from '../../store/slice'
import { formatPrice } from '../helper'
import { AddNewPackage } from './common/AddNewPackage'
import { ChoosePackageList } from './common/ChoosePackageList'
import { PackageItem } from './common/PackageItem'
import { Price } from './common/price'

export const BUY_MORE_PACKAGE_ID = 'BUY_MORE_PACKAGE_ID'

export const BuyMorePackage = ({ defaultReportId }) => {
  const dispatch = useDispatch()
  const { height } = useViewport()
  const buyPackage = useSelector(selectBuyPackage)
  const packageTypes = useSelector(selectUniquePackageTypes)
  const checkDiscountAndVoucher = useSelector(selectCheckDisCountAndVoucher)
  const dataVoucher = useSelector(selectVoucher)
  const discountOrder = useSelector(selectDiscountOrder)

  const { vatPercentage } = useGetVAT()

  const listPackage = buyPackage?.listPackage

  const totalAllPackagePrice = listPackage
    ?.map((item) => item.totalPrice || 0)
    .reduce((sum, acc) => sum + acc, 0)
  const totalDiscountProduct = listPackage
    ?.map((item) => item.totalPrice * item.discountPercentage || 0)
    .reduce((sum, acc) => sum + acc, 0)
  const priceDiscountRaw =
    (totalAllPackagePrice - totalDiscountProduct) *
      discountOrder?.discountPercentage || 0
  const priceVoucher = checkDiscountAndVoucher[CHECKBOX_TRADE_DISCOUNT.VOUCHER]
    ? (totalAllPackagePrice - totalDiscountProduct) *
      dataVoucher?.discountPercentage
    : 0
  const discountedPrice = formatPrice(priceDiscountRaw + priceVoucher)

  const priceNotIncludedVAT =
    totalAllPackagePrice - discountedPrice - totalDiscountProduct
  const vatPrice = vatPercentage * priceNotIncludedVAT
  const grandTotalPrice = priceNotIncludedVAT + vatPrice

  const onAddBtnClick = () => {
    dispatch(setListPackage([...listPackage, { rowId: listPackage.length }]))
  }

  useEffect(() => {
    dispatch(
      setListPackage([
        ...listPackage,
        {
          rowId: 1,
          packageTypeId: packageTypes[0]?.id,
          packageTypeName: packageTypes[0]?.name,
          pricingPackageId: packageTypes[0]?.pricingPackageId,
        },
      ]),
    )
  }, [])

  return (
    <>
      <div className={[classes.content, 'flexColumn h100'].join(' ')}>
        <div className="flex1">
          <ScrollComponent
            autoHeight
            autoHeightMax={height * 0.4}
            id={BUY_MORE_PACKAGE_ID}
          >
            <ChoosePackageList />
            {listPackage?.map((item, index) => (
              <div key={index}>
                <PackageItem
                  itemIndex={index}
                  defaultReportId={defaultReportId}
                  classNamePrice={classes.w150}
                />
                <Element className={classes.dashedLine} />
              </div>
            ))}
          </ScrollComponent>
        </div>
        <div className="flexColumn">
          <Element
            className={[classes.addNewPackage, 'flexRow'].join(' ')}
            onClick={onAddBtnClick}
          >
            <AddNewPackage />
          </Element>
          <Element
            style={{ backgroundColor: '#FFFFFF' }}
            className={classes.priceTotalContainer}
          >
            <Price
              title="userManagement.buyPackage.TOTAL_PRICE"
              price={totalAllPackagePrice ?? 0}
              classNamePrice={classes.w150}
            />
            <Price
              title="userManagement.packageSubManagement.TRADE_DISCOUNT"
              price={totalDiscountProduct}
              classNamePrice={classes.w150}
            />
            <Price
              title="userManagement.buyPackage.TRADE_DISCOUNT"
              price={discountedPrice ?? 0}
              classNamePrice={classes.w150}
              isDiscount
            />
            <Price
              title="userManagement.buyPackage.VAT"
              price={vatPrice ?? 0}
              classNamePrice={classes.w150}
            />
            <Price
              title="userManagement.buyPackage.GRAND_TOTAL"
              price={grandTotalPrice ?? 0}
              classNamePrice={classes.w150}
            />
          </Element>
        </div>
      </div>
    </>
  )
}
